import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IReferral } from '../../../models/IReferral';
import { Link } from 'react-router-dom';
import { PATIENT, REFERRAL } from '../../../utils/RouteConstants';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from '../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper';

interface IReferralSearchTable {
    referrals: IReferral[];
}

export const ReferralSearchTable: React.FunctionComponent<IReferralSearchTable> = ({ referrals }) => {

    const renderTableLink = (linkText?: string, patientGuidId?: string, referralId?: number) => {
        return <Link to={`${PATIENT}/${patientGuidId}/${REFERRAL}/${referralId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="ReferralDate" headerText="Datum" />
                    <SortableTableHeader propertyToSortBy="ReferralNumber" headerText="Remiss-ID" />
                    <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                    <th>Remittent</th>
                    <th>Remissmottagare</th>
                    <SortableTableHeader propertyToSortBy="ReferralStatus.Description" headerText="Status" />
                </tr>
            </thead>
            <tbody>
                {
                    referrals.length > 0 ?
                        referrals.map((referral, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(referral.dateSent), referral.patient?.patientGuidId, referral.referralId)}</td>
                                <td className="table-data-link">{renderTableLink(referral.referralNumber?.toString(), referral.patient?.patientGuidId, referral.referralId)}</td>
                                <td className="table-data-link">{renderTableLink(formatPersonalSecurityNumberAndOrganisationNumber(referral.patient?.personalSecurityNumber.toString()), referral.patient?.patientGuidId, referral.referralId)}</td>
                                <td className="table-data-link">{renderTableLink(referral.referrer?.name, referral.patient?.patientGuidId, referral.referralId)}</td>
                                <td className="table-data-link">{renderTableLink(referral.recipent?.name, referral.patient?.patientGuidId, referral.referralId)}</td>
                                <td className="table-data-link">{renderTableLink(referral.referralStatus, referral.patient?.patientGuidId, referral.referralId)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={6}>Hittade inga specialistremisser</td></tr>
                }
            </tbody>
        </Table>
    )
}